(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaPickingLine', PharmaPickingLine);

	PharmaPickingLine.$inject = [ '$resource' ];

	function PharmaPickingLine($resource) {
		var resourceUrl = 'api/pharma-picking-line/:id';

		return $resource(resourceUrl, {}, {
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();
